import { render, staticRenderFns } from "./Walkie.vue?vue&type=template&id=4d006423&scoped=true"
import script from "./Walkie.vue?vue&type=script&lang=js"
export * from "./Walkie.vue?vue&type=script&lang=js"
import style0 from "./Walkie.vue?vue&type=style&index=0&id=4d006423&prod&lang=stylus&rel=stylesheet%2Fstylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d006423",
  null
  
)

export default component.exports